{
  "page": {
    "title": "เชื่อมต่อ Chat Social",
    "loadFailed": "ไม่สามารถโหลดช่องทางได้",
    "lineConnected": "เชื่อมต่อ LINE OA สำเร็จ",
    "nameUpdated": "แก้ไขชื่อสำเร็จ",
    "activated": "เปิดใช้งานสำเร็จ",
    "deactivated": "ปิดใช้งานสำเร็จ",
    "statusCheckFailed": "ไม่สามารถตรวจสอบสถานะช่องทางได้ กรุณาลองใหม่",
    "toggleFailed": "เปลี่ยนสถานะช่องทางไม่สำเร็จ",
    "renameFailed": "เปลี่ยนชื่อช่องทางไม่สำเร็จ",
    "invalidConnectUrl": "URL การเชื่อมต่อไม่ถูกต้อง",
    "reconnectStartFailed": "ไม่สามารถเริ่มการเชื่อมต่อใหม่ได้",
    "tokenExpiredTitle": "โทเค็นช่องทางหมดอายุ",
    "tokenExpiredContent": "{{platform}} ของคุณต้องเชื่อมต่อใหม่ ดำเนินการต่อหรือไม่?",
    "tokenExpiredOk": "เชื่อมต่อใหม่",
    "tokenExpiredCancel": "ภายหลัง"
  },
  "section": {
    "addLine": "+ เพิ่ม LINE OA",
    "addFacebook": "+ เพิ่ม Facebook Page",
    "addInstagram": "+ เพิ่ม Instagram",
    "emptyLine": "ยังไม่มี LINE OA ที่เชื่อมต่อ",
    "emptyFacebook": "ยังไม่มี Facebook Page ที่เชื่อมต่อ",
    "emptyInstagram": "ยังไม่มี Instagram ที่เชื่อมต่อ"
  },
  "row": {
    "statusConnected": "เชื่อมต่อแล้ว",
    "statusInactive": "ปิดใช้งานอยู่",
    "statusReconnect": "ต้องเชื่อมต่อใหม่",
    "reconnectAria": "เชื่อมต่อช่องทางนี้ใหม่",
    "renameTooltip": "คลิกเพื่อแก้ไขชื่อ",
    "renameAria": "แก้ไขชื่อ {{name}}",
    "saveNameAria": "บันทึกชื่อ",
    "cancelAria": "ยกเลิก",
    "avatarAlt": "รูปโปรไฟล์ของ {{name}}",
    "deactivateTitle": "ปิดการใช้งานช่องทางนี้?",
    "activateTitle": "เปิดใช้งานช่องทางนี้?",
    "deactivateDescription": "ระบบจะหยุดรับข้อความจากช่องทางนี้ทันที",
    "activateDescription": "ระบบจะเริ่มรับข้อความจากช่องทางนี้อีกครั้ง",
    "deactivateOk": "ปิดใช้งาน",
    "activateOk": "เปิดใช้งาน",
    "confirmCancel": "ยกเลิก",
    "deactivateAria": "ปิดใช้งานช่องทาง",
    "activateAria": "เปิดใช้งานช่องทาง"
  },
  "lineWarning": {
    "title": "ข้อความที่ตอบจาก LINE OA Manager จะไม่ถูกบันทึก",
    "body": "LINE ไม่ส่งสำเนาข้อความที่ตอบจากแอป LINE OA Manager หรือเว็บ manager.line.biz กลับมายังระบบของเรา เพื่อให้ประวัติแชทตรงกัน กรุณาตอบลูกค้า LINE ผ่านระบบของเราเสมอ"
  },
  "facebook": {
    "title": "เชื่อมต่อ Facebook Page",
    "body": "คุณจะถูกนำไปยังหน้า Facebook เพื่ออนุญาตการเชื่อมต่อ ระบบจะเชื่อมต่อ Facebook Page ของคุณโดยอัตโนมัติ",
    "submit": "เชื่อมต่อ Facebook",
    "failed": "เชื่อมต่อ Facebook ไม่สำเร็จ"
  },
  "instagram": {
    "title": "เชื่อมต่อ Instagram",
    "body": "คุณจะถูกนำไปยังหน้า Instagram เพื่ออนุญาตการเชื่อมต่อ ระบบจะเชื่อมต่อบัญชี Instagram ของคุณโดยอัตโนมัติ",
    "submit": "เชื่อมต่อ Instagram",
    "failed": "เชื่อมต่อ Instagram ไม่สำเร็จ"
  },
  "tiktok": {
    "title": "เชื่อมต่อ TikTok",
    "body": "คุณจะถูกนำไปยังหน้า TikTok เพื่ออนุญาตการเชื่อมต่อ เมื่อเสร็จสิ้นระบบจะนำคุณกลับมาที่หน้านี้",
    "submit": "เชื่อมต่อ TikTok",
    "failed": "เชื่อมต่อ TikTok ไม่สำเร็จ"
  },
  "line": {
    "title": "เชื่อมต่อ LINE OA",
    "failed": "เชื่อมต่อ LINE OA ไม่สำเร็จ",
    "alreadyConnected": "LINE OA นี้เชื่อมต่อแล้ว",
    "copied": "คัดลอก Webhook URL แล้ว",
    "copyFailed": "คัดลอกไม่สำเร็จ กรุณาคัดลอกด้วยตนเอง",
    "step1Title": "ขั้นตอนที่ 1: ตั้งค่า Webhook ใน LINE OA Manager",
    "step1Open": "เปิด",
    "step1SelectAccount": "แล้วเลือกบัญชีของคุณ",
    "step1Settings": "คลิกไอคอน",
    "step1SettingsBold": "ตั้งค่า (Settings)",
    "step1SettingsAfter": "ที่มุมขวาบน",
    "step1MessagingBefore": "ไปที่เมนู",
    "step1MessagingAfter": "ที่แถบด้านซ้าย แล้วเปิดใช้งาน Messaging API (หากยังไม่ได้เปิด)",
    "step1WebhookBefore": "ในช่อง",
    "step1WebhookAfter": "ให้วาง URL ด้านล่างนี้ และกดบันทึก",
    "step2Title": "ขั้นตอนที่ 2: ออก Channel Access Token จาก LINE Developers Console",
    "step2Open": "เปิด",
    "step2SelectProvider": "แล้วเลือก Provider และ Messaging API channel เดียวกัน",
    "step2TabBefore": "ไปที่แท็บ",
    "step2TabMiddle": "ในหัวข้อ",
    "step2ToggleBefore": "ให้เปิดสวิตช์",
    "step2ToggleAfter": "(สำคัญมาก — ถ้าไม่เปิด LINE จะไม่ส่งข้อความมายังระบบของเรา) และเปิดสวิตช์",
    "step2RedeliveryAfter": "เพื่อให้ LINE ส่งข้อความซ้ำเมื่อระบบของเราขัดข้องชั่วคราว",
    "step2TokenBefore": "ในหน้าเดียวกัน เลื่อนลงไปที่หัวข้อ",
    "step2TokenMiddle": "แล้วกด",
    "step2TokenAfter": "เพื่อสร้างโทเค็น แล้วคัดลอกค่าที่ได้ มาวางในฟอร์มด้านล่าง",
    "step2SecretBefore": "ไปที่แท็บ",
    "step2SecretMiddle": "เพื่อคัดลอก",
    "step2SecretAfter": "มาวางในฟอร์มด้านล่าง",
    "copy": "คัดลอก",
    "copiedShort": "คัดลอกแล้ว",
    "webhookHint": "วาง URL นี้ในช่อง Webhook URL ของ LINE Official Account Manager",
    "channelNameLabel": "ชื่อ Channel",
    "channelNameRequired": "กรุณาระบุชื่อ Channel",
    "channelNamePlaceholder": "เช่น ร้านของฉัน",
    "tokenRequired": "กรุณาระบุ Channel Access Token",
    "tokenPlaceholder": "วาง Channel Access Token ที่นี่",
    "secretRequired": "กรุณาระบุ Channel Secret",
    "secretPlaceholder": "วาง Channel Secret ที่นี่",
    "cancel": "ยกเลิก",
    "submit": "เชื่อมต่อ"
  },
  "callback": {
    "successTikTok": "เชื่อมต่อ TikTok สำเร็จ",
    "successFacebook_other": "เชื่อมต่อ Facebook Page สำเร็จ ({{count}} เพจ)",
    "successInstagram_other": "เชื่อมต่อ Instagram สำเร็จ ({{count}} บัญชี)",
    "returning": "กำลังกลับไปหน้าตั้งค่า...",
    "failedFacebook": "เชื่อมต่อ Facebook Page ไม่สำเร็จ",
    "failedInstagram": "เชื่อมต่อ Instagram ไม่สำเร็จ",
    "failedTikTok": "เชื่อมต่อ TikTok ไม่สำเร็จ",
    "retry": "ลองใหม่อีกครั้ง",
    "goToChannels": "ไปที่ตั้งค่าช่องทาง",
    "pickerTitle": "เลือกเพจ Facebook ที่จะเชื่อมต่อ",
    "pickerSub": "ร้านนี้รองรับการเชื่อมต่อ 1 เพจต่อร้าน เลือกเพจที่ต้องการใช้รับข้อความ",
    "pickerLoading": "กำลังโหลดรายชื่อเพจ...",
    "pickerCancel": "ยกเลิก",
    "pickerSubmit": "เชื่อมต่อเพจนี้",
    "pickerSubmitting": "กำลังเชื่อมต่อ...",
    "pickerExpired": "ลิงก์เลือกเพจหมดอายุ กรุณาเชื่อมต่อใหม่อีกครั้ง",
    "pickerNotOwned": "ลิงก์นี้ไม่ใช่ของบัญชีที่กำลังใช้งาน กรุณาเชื่อมต่อใหม่",
    "pickerLoadFailed": "ไม่สามารถโหลดรายชื่อเพจได้ กรุณาลองใหม่",
    "selectExpired": "ลิงก์หมดอายุ กรุณาเชื่อมต่อใหม่อีกครั้ง",
    "selectChannelLimit": "ร้านนี้มีเพจ Facebook ที่เชื่อมต่ออยู่แล้ว กรุณายกเลิกเพจเดิมก่อน",
    "selectFailed": "ไม่สามารถเชื่อมต่อเพจที่เลือกได้",
    "fbAccessDenied": "คุณปฏิเสธการอนุญาต หรือยังไม่ได้เลือกเพจ กรุณาลองใหม่และเลือกเพจที่ต้องการ",
    "fbInvalidState": "ลิงก์หมดอายุ กรุณาลองใหม่",
    "fbTokenExchangeFailed": "ไม่สามารถเชื่อมต่อได้ กรุณาลองใหม่",
    "fbChannelLimit": "ร้านนี้เชื่อมต่อเพจ Facebook ไว้แล้ว (จำกัด 1 เพจต่อร้าน) หากต้องการเปลี่ยนเพจ กรุณายกเลิกเพจเดิมในหน้าตั้งค่าช่องทางก่อน แล้วเชื่อมต่อใหม่",
    "fbNoPages": "ไม่พบเพจที่เชื่อมต่อได้ กรุณาตรวจสอบว่าคุณเป็นผู้ดูแลเพจ และได้ให้สิทธิ์เข้าถึงเพจ",
    "fbPickerLoadFailed": "ไม่สามารถโหลดรายชื่อเพจได้ กรุณาเชื่อมต่อใหม่",
    "genericError": "เกิดข้อผิดพลาด กรุณาลองใหม่",
    "igAccessDenied": "คุณปฏิเสธการอนุญาต กรุณาลองใหม่",
    "igInvalidState": "ลิงก์หมดอายุ กรุณาลองใหม่",
    "igMissingCode": "การเชื่อมต่อไม่สมบูรณ์ กรุณาลองใหม่",
    "igTokenExchangeFailed": "ไม่สามารถเชื่อมต่อกับ Instagram ได้ กรุณาลองใหม่",
    "igNoAccounts": "ไม่พบบัญชี Instagram Business ที่ผูกกับเพจ Facebook กรุณาตรวจสอบการตั้งค่าบัญชี",
    "igSelectOne": "พบหลายบัญชี กรุณาอนุญาตเพียง 1 เพจ (ที่ผูก Instagram 1 บัญชี) แล้วลองใหม่",
    "igChannelLimit": "มีบัญชี Instagram เชื่อมต่ออยู่แล้ว กรุณายกเลิกบัญชีเดิมก่อนเชื่อมต่อบัญชีใหม่",
    "igConnectFailed": "ไม่สามารถเชื่อมต่อบัญชี Instagram ได้ กรุณาตรวจสอบสิทธิ์",
    "loginSuccess": "เข้าสู่ระบบ Facebook แล้ว",
    "loginSuccessAs": "เข้าสู่ระบบ Facebook ในชื่อ {{name}}",
    "linkedChannelLimit": "ร้านนี้มีเพจ Facebook เชื่อมต่ออยู่แล้ว (จำกัด 1 เพจต่อร้าน) จึงยังไม่ได้เพิ่มเพจใหม่ คุณสามารถเปลี่ยนเพจได้ด้านล่าง หรือจัดการในหน้าตั้งค่าช่องทาง",
    "linkedNoPages": "บัญชี Facebook นี้ไม่ได้เป็นผู้ดูแลเพจที่เชื่อมต่อได้ กรุณาสร้างเพจ หรือขอสิทธิ์ผู้ดูแลเพจ แล้วเชื่อมต่อใหม่อีกครั้ง",
    "linkedOwnedElsewhere": "เพจนี้เชื่อมต่อกับร้านอื่นอยู่ กรุณายกเลิกการเชื่อมต่อที่ร้านนั้นก่อน แล้วเชื่อมต่อใหม่",
    "linkedGeneric": "ยังไม่ได้เชื่อมต่อเพจในครั้งนี้ กรุณาลองอีกครั้ง",
    "replaceTitle": "เปลี่ยนเพจที่เชื่อมต่อ",
    "replaceSub": "ตอนนี้เชื่อมต่อ {{current}} อยู่ เลือกเพจที่ต้องการใช้รับข้อความแทน",
    "replaceSubmit": "เปลี่ยนเพจที่เชื่อมต่ออยู่",
    "replaceConfirmTitle": "เปลี่ยนจาก {{current}} ใช่หรือไม่?",
    "replaceConfirmBody": "{{current}} จะหยุดรับข้อความใน Sight Order และจะเชื่อมต่อ {{next}} แทน ประวัติการสนทนาเดิมจะยังอยู่ครบ",
    "replaceConfirmOk": "ใช่ เปลี่ยนเลย",
    "replaceCancel": "ใช้เพจเดิมต่อไป",
    "replaceSubmitting": "กำลังเปลี่ยน...",
    "replaceFailed": "ไม่สามารถเปลี่ยนเพจได้ กรุณาลองใหม่",
    "replaceAmbiguous": "ร้านนี้มีเพจ Facebook เชื่อมต่ออยู่หลายเพจ จึงไม่มีเพจเดียวที่จะเปลี่ยนแทนได้ กรุณายกเลิกเพจที่ต้องการเปลี่ยนในหน้าตั้งค่าช่องทางก่อน",
    "pageUnavailable": "ใช้ไม่ได้: Facebook ไม่อนุญาตให้ Sight Order รับข้อความของเพจนี้",
    "selectSubscribeFailed": "Facebook ไม่อนุญาตให้ Sight Order รับข้อความของเพจนั้น จึงยังไม่ได้เชื่อมต่อ กรุณาเลือกเพจอื่น หรือตรวจสอบว่าคุณมีสิทธิ์ควบคุมเพจนี้ทั้งหมด",
    "linkedSubscribeFailed": "Facebook ไม่อนุญาตให้ Sight Order รับข้อความของเพจนี้ จึงยังไม่ได้เชื่อมต่อ กรุณาตรวจสอบว่าคุณมีสิทธิ์ควบคุมเพจทั้งหมด แล้วเชื่อมต่อใหม่อีกครั้ง",
    "replaceSubscribeFailed": "Facebook ไม่อนุญาตให้ Sight Order รับข้อความของเพจนั้น เพจเดิมของคุณจึงยังเชื่อมต่ออยู่"
  }
}
